module.exports = __webpack_public_path__ + "img/header_text_horizontal.c84475fd.png";